import { useBizApiClient } from "../_base/useBizApiClient";
const useAuditorGetShareClient = () => {
  const [getShareDetails, result] = useBizApiClient({
    name: `getAuditorShares`,
    method: "get",
    path: `/auditor/shares`
  });
  return [getShareDetails, result];
};
const useAuditorAcceptShareClient = () => {
  const [acceptShare, result] = useBizApiClient({
    name: `auditorAcceptShare`,
    method: "post",
    path: `/auditor/share/accept`
  });
  return [acceptShare, result];
};
const useAuditorRemoveShareClient = () => {
  const [removeShare, result] = useBizApiClient({
    name: `auditorRemoveShare`,
    method: "post",
    path: `/auditor/share/remove`
  });
  return [removeShare, result];
};
export { useAuditorGetShareClient, useAuditorAcceptShareClient, useAuditorRemoveShareClient };